import { Component, Mixins } from 'vue-property-decorator';
import CalendarCard from '../detail';
import CalendarHead from '../head';
import { DAYS_OF_WEEK } from './const';
import Props from './props';
import { fillWeek, getNextMonth, getPrevMonth } from './tools';
import {
  format,
  isPast,
  isToday,
  getDaysInMonth,
  isWithinRange,
  endOfDay,
  startOfDay,
} from 'date-fns';

@Component({
  components: {
    CalendarCard,
    CalendarHead,
  },
})
export default class CalendarMonth extends Mixins(Props) {
  // Readonly
  readonly days = DAYS_OF_WEEK;

  // Computed
  get nextMonth() {
    return getNextMonth(this.month);
  }

  get nextMonthRoute() {
    const params = { ...this.$route.params };
    let { year } = this;
    let month = this.month + 1;
    if (month > 12) {
      year = year + 1;
      month = 1;
    }
    return {
      params,
      name: this.$route.name,
      query: { ...this.$route.query, month, year },
    };
  }

  get prevMonth() {
    return getPrevMonth(this.month);
  }

  get prevMonthRoute() {
    const params = { ...this.$route.params };
    let { year } = this;
    let month = this.month - 1;
    if (month < 1) {
      year = year - 1;
      month = 12;
    }
    return {
      params,
      name: this.$route.name,
      query: {  ...this.$route.query, month, year },
    };
  }

  get weeks() {
    const { items, year } = this;
    const month = this.month - 1;
    const daysInMonth = getDaysInMonth(new Date(year, month));
    const prevMonth = 0;
    const nextMonth = daysInMonth + 1;
    const weeks: Array<Array<any>> = [];
    const params = { ...this.$route.params };
    const query = { ...this.$route.query };
    delete query.month;
    delete query.year;

    let week = fillWeek();
    let filled = false;

    for (let date = prevMonth; date <= nextMonth; date++) {
      const day = new Date(year, month, date);
      let dayOfWeek = day.getDay() - 1;
      if (dayOfWeek < 0) dayOfWeek = 6;

      let curr;
      if (date === prevMonth) curr = { prev: true };
      else if (date === nextMonth) curr = { next: true };
      else {
        const activities = items.filter(({ date }) =>
          isWithinRange(date, startOfDay(day), endOfDay(day))
        );

        curr = {
          day,
          completed: isPast(day) && !isToday(day),
          count: activities.reduce((sum, { count }) => sum + count, 0),
          date: day.getDate(),
          to:
            activities.length === 0
              ? false
              : {
                  params,
                  name: 'activities',
                  query: {
                    ...query,
                    date: format(new Date(year, month, date), 'YYYY-MM-DD'),
                  },
                },
        };
      }

      week[dayOfWeek] = curr;
      filled = true;

      if (dayOfWeek === 6) {
        weeks.push([...week]);
        week = fillWeek();
        filled = false;
      }
    }

    if (filled) weeks.push([...week]);
    return weeks;
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/month/script.ts